interface LedgerRowHeaderProps {
  rows: string[];
}
export const LedgerRowHeader: React.FC<LedgerRowHeaderProps> = ({ rows }) => (
  <div className="ledger-grid ledger-view-header font-semibold font-primary-semibold">
    {rows?.map((row, index) => (
      <span className="ledger-view-header-text" key={index}>
        {row}
      </span>
    ))}
  </div>
);
